import { Button, Drawer, Table, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { UserInfo } from "../../../context";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";

const MerchantReportOrderDetails = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const [totalCost, setTotalCost] = useState(0);
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "product",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Price x Quantity",
      align: "right",
      render: (text, record) => (
        <>
          &#8369;{text.price} x {text.quantity}
        </>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantInvoiceDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      transaction_id: selectedData !== null ? selectedData.transaction_id : "",
    };
    axios
      .get("user/merchant/spec-transaction-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setOrderDetailsList({ data, ready: true });
        setTotalCost(calculateTotal(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].quantity) * parseFloat(data[i].price);
    }
    return total;
  };

  useEffect(() => {
    getMerchantInvoiceDetails();
  }, [getMerchantInvoiceDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
    },
  });

  return (
    <Drawer
      title="Receipt"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <>
          <div
            style={{ overflowX: "auto", padding: paddingPrint }}
            ref={componentRef}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingRight: 15,
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                Customer Name:{" "}
                {orderDetailsList.ready &&
                  orderDetailsList.data[0].customer_name}
              </Typography>
              <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                Table Number:{" "}
                {orderDetailsList.ready && orderDetailsList.data[0].table_no}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  textTransform: "capitalize",
                }}
              >
                Status:{" "}
                {orderDetailsList.ready &&
                  orderDetailsList.data[0].service_category}
              </Typography>
            </div>

            <Table
              {...tableProps}
              pagination={false}
              columns={tableColumns}
              dataSource={
                orderDetailsList.data.length > 0 ? orderDetailsList.data : []
              }
              scroll={scroll}
              rowKey={(record) => record.product}
            />

            <div style={{ display: "flex", paddingRight: 15, marginTop: 10 }}>
              <div style={{ flexGrow: 1 }} />
              <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                Total Cost: &#8369;
                {totalCost.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </div>
            <div style={{ display: "flex", paddingRight: 15 }}>
              <div style={{ flexGrow: 1 }} />
              <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                Payment: &#8369;
                {parseFloat(
                  orderDetailsList.ready && orderDetailsList.data[0].payment
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </div>
            <div style={{ display: "flex", paddingRight: 15 }}>
              <div style={{ flexGrow: 1 }} />
              <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                Change: &#8369;
                {(
                  parseFloat(
                    orderDetailsList.ready && orderDetailsList.data[0].payment
                  ) - parseFloat(totalCost)
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </div>
          </div>
          <div style={{ display: "flex", marginTop: 10 }}>
            <div style={{ flexGrow: 1 }} />
            <div>
              <Button
                type="primary"
                onClick={handlePrint}
                icon={<PrinterOutlined />}
              >
                Print
              </Button>
            </div>
          </div>
        </>
      )}
    </Drawer>
  );
};

export default MerchantReportOrderDetails;
